import { createSelector } from "reselect";

export const getRastreamento = (state) => state.rastreamento;
export const getDominios = createSelector(
  getRastreamento,
  (state) => state.dominios
);
export const getOpcoesMapa = createSelector(
  getRastreamento,
  (state) => state.opcoes
);
export const getFiltros = createSelector(
  getRastreamento,
  (state) => state.filtros
);
export const getDrawer = createSelector(
  getRastreamento,
  (state) => state.drawer
);
export const getBotao = createSelector(getRastreamento, (state) => state.botao);
export const getDominioEmpresas = createSelector(
  getDominios,
  (state) => state.empresas
);
export const getDominioRoteiros = createSelector(
  getDominios,
  (state) => state.roteiros
);
export const getDominioDispositivos = createSelector(
  getDominios,
  (state) => state.dispositivos
);

export const isLoadingItems = createSelector(
  getRastreamento,
  (state) => state.loading
);
export const isUpdatingItem = createSelector(
  getRastreamento,
  (state) => state.updating
);
export const getItems = createSelector(getRastreamento, (state) => state.items);
export const getKml = createSelector(getRastreamento, (state) => state.kml);
export const getEmpresa = createSelector(
  getRastreamento,
  (state) => state.empresa
);

export const getRoteiro = createSelector(
  getRastreamento,
  (state) => state.roteiro
);
export const getOs = createSelector(getRastreamento, (state) => state.os);

export const getCenter = (state) => {
  const items = getItems(state);

  if (items?.length > 0) {
    const allPositions = items.flatMap((item) => item.posicoes || []);

    const primeiroPontoValido = allPositions.find(
      (p) => p.tipo === "P" && p.situacao === "V"
    );
    if (primeiroPontoValido?.longitudeLatitude) {
      return primeiroPontoValido.longitudeLatitude;
    }

    const primeiroCheckpoint = allPositions.find((p) => p.tipo === "C");
    if (primeiroCheckpoint?.longitudeLatitude) {
      return primeiroCheckpoint.longitudeLatitude;
    }

    const primeiroComUltimaPosicao = items.find(
      (item) => item.ultimaPosicaoLat != null && item.ultimaPosicaoLong != null
    );
    if (primeiroComUltimaPosicao) {
      return {
        lat: primeiroComUltimaPosicao.ultimaPosicaoLat,
        lng: primeiroComUltimaPosicao.ultimaPosicaoLong,
      };
    }
  }

  return state.usuario.position;
};
